import { useContext } from 'react'
import { AuthContext } from '../../modules/auth/authContext'
import { Icon } from '../Icon'
import { navigationConfig } from './config'
import { NavMain } from '../navbar/nav-main'
import { NavUser } from '../navbar/nav-user'
import { NavChatlio } from '../navbar/nav-chatlio'
import { NavSlack } from '../navbar/nav-slack'

import {
    Sidebar,
    SidebarProvider,
    SidebarHeader,
    SidebarContent,
    SidebarFooter,
    SidebarLogo,
    SidebarMenu,
    SidebarTrigger,
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenuItem,
} from '../ui/sidebar'

import { TooltipProvider } from '../ui/tooltip'
import { LocalStorageKey } from '@/lib/storageConstants'

// Main SideNavigation component
export const SideNavigation = () => {
    const { client, user } = useContext(AuthContext)
    const selfServe = client?.selfServe

    const handleClientChange = (clientHash: string) => {
        window.localStorage.setItem(LocalStorageKey.CLIENT_HASH, clientHash)
        window.location.href = '/'
    }

    // Prepare user data for NavUser component
    const userData = {
        name: user?.name || 'User',
        email: user?.username || 'user@example.com',
        avatar: client?.imageUrl || '',
    }

    // Filter enabled items
    const mainItems = navigationConfig.mainItems.filter((item) => item.enabled)
    const userMenuItems = navigationConfig.userMenu.filter((item) =>
        item.label === 'Billing' ? item.enabled && selfServe : item.enabled,
    )

    // We'll have separate providers for desktop and mobile to allow different sidebar positions
    return (
        <>
            {/* Desktop Navigation - From Left */}
            <div className="hidden size-full md:block">
                <TooltipProvider delayDuration={200}>
                    <SidebarProvider>
                        <Sidebar variant="inset" className="h-full" side="left">
                            <SidebarHeader>
                                <SidebarMenu>
                                    <SidebarLogo
                                        logo={
                                            <Icon
                                                type="square-logo"
                                                color="currentColor"
                                                width={30}
                                                height={30}
                                            />
                                        }
                                        title="Black Crow AI"
                                        subtitle="Full Funnel Creative Platform"
                                        href="/"
                                    />
                                </SidebarMenu>
                            </SidebarHeader>

                            <SidebarContent>
                                <NavMain items={mainItems} />
                            </SidebarContent>

                            <SidebarFooter>
                                <SidebarGroup className="mb-2">
                                    <SidebarGroupContent>
                                        <SidebarMenu className="gap-2">
                                            <SidebarMenuItem>
                                                <NavSlack />
                                            </SidebarMenuItem>
                                            <SidebarMenuItem>
                                                <NavChatlio />
                                            </SidebarMenuItem>
                                        </SidebarMenu>
                                    </SidebarGroupContent>
                                </SidebarGroup>
                                <NavUser
                                    user={userData}
                                    client={client}
                                    menuItems={userMenuItems}
                                    onClientChange={handleClientChange}
                                />
                            </SidebarFooter>
                        </Sidebar>
                    </SidebarProvider>
                </TooltipProvider>
            </div>

            {/* Mobile Navigation - From Right */}
            <div className="block size-full md:hidden">
                <TooltipProvider delayDuration={200}>
                    <SidebarProvider>
                        <div className="fixed left-4 top-6 z-[60]">
                            <SidebarTrigger
                                className="rounded-md border p-2 shadow-md bg-white border-gray-200"
                                size="lg"
                            />
                        </div>
                        <Sidebar variant="inset" className="h-full bg-muted">
                            <SidebarHeader>
                                <SidebarMenu>
                                    <SidebarLogo
                                        logo={
                                            <Icon
                                                type="square-logo"
                                                color="currentColor"
                                                width={30}
                                                height={30}
                                            />
                                        }
                                        title="Black Crow AI"
                                        subtitle="Full Funnel Creative Platform"
                                        href="/"
                                    />
                                </SidebarMenu>
                            </SidebarHeader>

                            <SidebarContent>
                                <NavMain items={mainItems} />
                            </SidebarContent>

                            <SidebarFooter>
                                <SidebarGroup className="mb-2">
                                    <SidebarGroupContent>
                                        <SidebarMenu>
                                            <SidebarMenuItem>
                                                <NavSlack />
                                            </SidebarMenuItem>
                                            <SidebarMenuItem>
                                                <NavChatlio />
                                            </SidebarMenuItem>
                                        </SidebarMenu>
                                    </SidebarGroupContent>
                                </SidebarGroup>
                                <NavUser
                                    user={userData}
                                    client={client}
                                    menuItems={userMenuItems}
                                    onClientChange={handleClientChange}
                                />
                            </SidebarFooter>
                        </Sidebar>
                    </SidebarProvider>
                </TooltipProvider>
            </div>
        </>
    )
}
